import { render, staticRenderFns } from "./kt&gDetailList.vue?vue&type=template&id=34b7115e&"
import script from "./kt&gDetailList.vue?vue&type=script&lang=js&"
export * from "./kt&gDetailList.vue?vue&type=script&lang=js&"
import style0 from "./kt&gDetailList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./kt&gDetailList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports